export var ChromeSetting;
(function (ChromeSetting) {
    ChromeSetting[ChromeSetting["None"] = 0] = "None";
    ChromeSetting[ChromeSetting["Off"] = 1] = "Off";
    ChromeSetting[ChromeSetting["Small"] = 2] = "Small";
    ChromeSetting[ChromeSetting["TopBarOnly"] = 3] = "TopBarOnly";
    ChromeSetting[ChromeSetting["TopBarFolderTreeCollapsed"] = 4] = "TopBarFolderTreeCollapsed";
    ChromeSetting[ChromeSetting["NoTopBarHasFolderTree"] = 5] = "NoTopBarHasFolderTree";
    ChromeSetting[ChromeSetting["NoTopBarFolderTreeCollapsed"] = 6] = "NoTopBarFolderTreeCollapsed";
})(ChromeSetting || (ChromeSetting = {}));
;
